import React from "react";

import { isLbsMeet, isKgMeet, getMeetUnits } from "util/meetHelper";
import { toKg, toLbs } from "util/conversions";
import DisplayComponent from "./DisplayComponent";
import { Attempt, Meet } from "types";
import get from "lodash/get";
import capitalize from "lodash/capitalize";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";

const AttemptInfo = ({
  meet,
  currentAttempt,
  id,
}: {
  meet: Meet;
  currentAttempt: Attempt | undefined | null;
  id: WidgetId;
}) => {
  const { editMode } = useDisplaySettings();
  return (
    <DisplayComponent style={{ top: 44, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 28,
        };

        let liftName = get(currentAttempt, "liftName", "Lift");
        if (liftName === "bench" && meet.federation === "USSF") {
          liftName = "press";
        }

        let attemptNumber = get(currentAttempt, "attemptNumber", "0");
        let currentWeight = get(currentAttempt, "weight", "000");

        if (editMode) {
          liftName = "Squat";
          attemptNumber = "1";
          currentWeight = 400;
        }

        return (
          <div style={style} className="lifter-details">
            <div>
              {capitalize(liftName)}-{attemptNumber}: {currentWeight}{" "}
              {getMeetUnits(meet)}
              <span style={{ fontSize: style.fontSize * 0.6 }}>
                {isLbsMeet(meet) && (
                  <span> ({toKg(Number(currentWeight)).toFixed(2)} kg)</span>
                )}
                {isKgMeet(meet) && (
                  <span> ({toLbs(Number(currentWeight)).toFixed(2)} lbs)</span>
                )}
              </span>
            </div>
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default AttemptInfo;
